import Vue from 'vue';
import { nrAgent, reportMemory } from './newrelic';
import AppGenefox from './index';
import { GenefoxApi, GenefoxDownloadFile, GenefoxMultipartApi } from '@/service/http-common';
import Keycloak from 'keycloak-js';

initApp();

let memoryReportingTimer;

async function initApp() {
  let configPath = '/config.json';
  if (process.env.VUE_APP_ENV === 'development') {
    configPath = '/config-dev.json';
  }
  const response = await fetch(configPath);
  const config = await response.json();
  window.top.applicationConfig = config.application;
  GenefoxApi.defaults.baseURL = window.top.applicationConfig.backendUrl;
  GenefoxMultipartApi.defaults.baseURL = window.top.applicationConfig.backendUrl;
  GenefoxDownloadFile.defaults.baseURL = window.top.applicationConfig.backendUrl;
  initAppWithKeycloak(config);
}
async function initAppWithKeycloak(config) {
  const keycloakConfig =  config.keycloak;

  const initOptions = {
    url: keycloakConfig.url,
    realm: keycloakConfig.realm,
    clientId: keycloakConfig.clientId,
    onLoad: 'login-required'
  };

  const keycloak = new Keycloak(initOptions);

  keycloak.init({ onLoad: initOptions.onLoad, checkLoginIframe: false, pkceMethod: 'S256' }).then(auth => {
    if (!auth) {
      window.location.reload();
    }

    localStorage.setItem('vue-token', keycloak.token);

    const getNewRelicContext = () => ({
      userName: AppGenefox.$store.getters['security/userName'] || '',
      laboratory: AppGenefox.$store.getters['security/userLaboratory'] || ''
    });

    Vue.config.errorHandler = (error, instance, info) => {
      const nrContext = getNewRelicContext();
      nrAgent.noticeError(error, {
        vueComponent: instance?.$options?.name || 'unknown',
        vueInfo: info,
        userName: nrContext.userName,
        laboratory: nrContext.laboratory
      });
      reportMemory(nrContext);
      console.error(error);
    };

    initAppAndModulesSecurityStore(keycloak);
    reportMemory(getNewRelicContext());
    if (memoryReportingTimer) {
      clearInterval(memoryReportingTimer);
    }
    memoryReportingTimer = setInterval(() => {
      reportMemory(getNewRelicContext());
    }, 60_000);
    mountAppAndModules();
    initKeycloakTokenAutoRefresh(keycloak);

    if (!AppGenefox.$router.currentRoute?.name) { // Avoid NavigationDuplicated error
      // NOTE: Required for Firefox usage. Trigger that initial Vue-router init when being redirected from Keycloak
      AppGenefox.$router.push(window.location.hash.substring(1));
    }
  }).catch(error => {
    console.log(`Authentication Failed ${error}`);
  });
}

function mountAppAndModules() {
  AppGenefox.$mount('#app');
}

function initAppAndModulesSecurityStore(keycloakInstance) {
  AppGenefox.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
}

function initKeycloakTokenAutoRefresh(keycloakInstance) {
  setInterval(() => {
    keycloakInstance.updateToken(70).then(refreshed => {
      if (refreshed) {
        localStorage.setItem('vue-token', keycloakInstance.token);
        initAppAndModulesSecurityStore(keycloakInstance);
      }
    }).catch(() => {
      console.log('Failed to refresh token');
    });
  }, 5000);
}
